import PropTypes from 'prop-types';
import React from 'react';

class HotelListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      selected: props.hotel.selected?true:false, 
      favorite: props.hotel.favorite, 
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFavorite = this.handleFavorite.bind(this);
    this.handleDisplay = this.handleDisplay.bind(this);
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.hotel.selected !== this.props.hotel.selected) {
      this.setState({
        selected: nextProps.hotel.selected
      })
    }
    if (nextProps.hotel.favorite !== this.props.hotel.favorite) {
      this.setState({
        favorite: nextProps.hotel.favorite
      })
    }
  }

  handleChange(e) {
    e.preventDefault();
    const bidData =this.props.event.event.bids.bid_details
    let counter =0
    for(let i=0;i<bidData.length;i++){
      if(bidData[i].check_in_date !== null){
        counter+=1
      }
    }
    //if (this.props.event.event.bids.bid_details.filter(o => o.suite || o.double || o.king).length !== this.props.event.selectedTour.tour.groups.find(o => o.id == this.props.groupId).members_count) {
      // !this.props.event.event.bids.bid_details.filter(o => o.group_id == this.props.groupId && o.event_id == this.props.event.event.id).length
    if (counter<=0){
      this.props.displayError()
    }
    else {
      this.setState(prevState => ({
        selected: !prevState.selected,
      }));
      this.props.selectHotel({ hotel: this.props.hotel.id, selected: !this.state.selected, tourgroup_id: this.props.groupId });
    }
  }
  handleFavorite(e) {
    e.preventDefault();
    this.setState(prevState => ({
      favorite: !prevState.favorite,
    }));
    this.props.favoriteHotel(this.props.hotel.id, !this.state.favorite);
  }
  handleDisplay(e) {
    e.preventDefault();
    this.props.displayHotel(this.props.hotel.id);
  }

  render() {
    const color = this.props.hotel.management?'green':' ';
    const weight = this.state.selected ? 'Bold' : 'normal';
    return (
      <li
        style={{
          color,
          fontWeight:weight,
          borderBottom: '1px solid #f0f0f0',
          width: '100%',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <div>
          <input
            id={this.props.hotel.id}
            type="checkbox"
            checked={this.state.selected}
            onChange={this.handleChange}
          />
          <span
            className={this.state.favorite ? 'fa fa-heart text-danger' : 'fa fa-heart-o'}
            onClick={this.handleFavorite}
            role="button"
          />
          <span className="pointer-hover" onClick={this.handleDisplay} role="presentation">
            <span>
              {this.props.hotel.name}&nbsp;
              {this.props.hotel.management && <i style={{ color: 'green' }} className="fa fa-check-circle" />}
            </span>
          </span>
          <div>
            <div className="hotel-distance">
              {this.props.hotel.stars ? this.props.hotel.stars : <span>Not available</span>}{' '}
              <span className="fa fa-star" />
              <a
                href={this.props.hotel.website}
                title={this.props.hotel.website}
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className={this.props.hotel.website ? 'fa fa-external-link' : 'hidden'} />
              </a>
              <span>
                ({parseFloat(this.props.hotel.distance * 0.621371).toFixed(2)} mi. from venue)
              </span>
            </div>
          </div>
        </div>
        <div className="hotel-details text-muted">
          <p style={{color,}}>
            <i className="fa fa-map-marker" />
            {this.props.hotel.address}, &nbsp;
            {this.props.hotel.locality}, &nbsp;
            {this.props.hotel.region}, &nbsp;
            {this.props.hotel.postcode}, &nbsp;
            {this.props.hotel.tel},
          </p>
        </div>
      </li>
    );
  }
}

HotelListItem.propTypes = {
  hotel: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    selected: PropTypes.bool.isRequired,
    favorite: PropTypes.bool.isRequired,
    address: PropTypes.string,
    locality: PropTypes.string,
    region: PropTypes.string,
    postcode: PropTypes.string,
    tel: PropTypes.string,
    website: PropTypes.string,
    distance: PropTypes.number,
    stars: PropTypes.number,
    management: PropTypes.object,
  }),
  favoriteHotel: PropTypes.func.isRequired,
  selectHotel: PropTypes.func.isRequired,
  displayHotel: PropTypes.func.isRequired,
};

HotelListItem.defaultProps = {
  hotel: {
    selected: false,
  },
};
export default HotelListItem;


// WEBPACK FOOTER //
// src/routes/tours/components/HotelListItem.js